import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import WebsiteLayout from '../layouts/WebsiteLayout';
import axios from 'axios';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button, TextField } from '@mui/material';

const Contact = () => {
  const { t, i18n } = useTranslation();
  const [success, setSuccess] = useState(false);
  const isFrench = i18n.language === 'fr';

  const metaTitle = isFrench
    ? 'Contactez TransportSansGaz | Transport Dédié Écoresponsable'
    : 'Contact TransportSansGaz | Carbon-Neutral Transport in Quebec';

  const metaDescription = isFrench
    ? 'Contactez TransportSansGaz pour un transport dédié, écologique et carbone neutre entre Montréal et Québec. Demandez un devis ou plus d’informations dès maintenant.'
    : 'Get in touch with TransportSansGaz for dedicated, eco-friendly transport between Montreal and Quebec. Request a quote or ask about our carbon-neutral solutions today.';

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    description: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    // Construct the payload
    const payload = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      message: formData.description,
    };

    try {
      const response = await axios.post(
        'https://hook.us2.make.com/6xk2wj9kxsc05bv55v4bunc54n1o3vqb',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      setSuccess(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        description: '',
      });
    } catch (error) {
      console.error('Error submitting the form:', error);
      alert('Une erreur est survenue lors de l’envoi. Veuillez réessayer.');
    }
  };

  return (
    <WebsiteLayout>
      <Helmet>
        <html lang={isFrench ? 'fr' : 'en'} />
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>
      <div className="mt-5 container">
        <div style={{ minHeight: '80vh', marginTop: '200px' }}>
          <div className="row">
            <div className="col-md-6 col-12">
              <img
                src="./img/contact-tsg.jpeg"
                height={550}
                width={550}
                style={{ borderRadius: '20px', objectFit: 'cover' }}
              />
            </div>{' '}
            <div className="col-md-6 col-12">
              <h1 className="title">
                {t('contactTop')}{' '}
                <span className="gradient-text">{t('contactGrad')} </span>
              </h1>
              <p className="text mt-3">{t('contactTxt')}</p>
              {success ? (
                <div
                  style={{
                    textAlign: 'center',
                    paddingTop: '40px',
                    paddingBottom: '40px',
                  }}
                >
                  <CheckCircleIcon sx={{ fontSize: 60, color: '#04aee7' }} />
                  <h5 style={{ marginTop: '10px' }}>
                    Votre demande a bien été envoyée !
                  </h5>
                  <p>
                    Vous recevrez une réponse dans les plus brefs délais par
                    courriel.
                  </p>
                </div>
              ) : (
                <>
                  <TextField
                    fullWidth
                    label={t('formName')}
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    margin="normal"
                  />
                  <TextField
                    fullWidth
                    label={t('formEmail')}
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    margin="normal"
                  />
                  <TextField
                    fullWidth
                    label={t('formPhone')}
                    name="phone"
                    type="tel"
                    value={formData.phone}
                    onChange={handleChange}
                    margin="normal"
                  />
                  <TextField
                    fullWidth
                    label={t('formDescription')}
                    name="description"
                    type="text"
                    margin="normal"
                    multiline
                    rows={4}
                    value={formData.description}
                    onChange={handleChange}
                  />
                  <Button
                    sx={{
                      borderRadius: '30px',
                      backgroundColor: '#04aee7',
                      padding: '8px 20px',
                    }}
                    disableElevation
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                  >
                    {t('submit')}
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </WebsiteLayout>
  );
};

export default Contact;
